var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPhotoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#CFE1EE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27C31.4531 27 37.5 20.9531 37.5 13.5C37.5 6.04688 31.4531 0 24 0C16.5469 0 10.5 6.04688 10.5 13.5C10.5 20.9531 16.5469 27 24 27ZM36 30H30.8344C28.7531 30.9562 26.4375 31.5 24 31.5C21.5625 31.5 19.2563 30.9562 17.1656 30H12C5.37188 30 0 35.3719 0 42V43.5C0 45.9844 2.01562 48 4.5 48H43.5C45.9844 48 48 45.9844 48 43.5V42C48 35.3719 42.6281 30 36 30Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPhotoIcon);
export default __webpack_public_path__ + "static/media/user-photo-icon.64e2a7c9.svg";
export { ForwardRef as ReactComponent };